import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';

@Component({
    selector: 'atx-table-pagination',
    template: `<nav aria-label="Page navigation example">
    <ul class="pagination pagination-sm justify-content-{{ justifyContent }}">
        <li class="page-item"
            [class.disabled]="hasFirstPage">
            <a class="page-link" (click)="prevPage()">
                <
            </a>
        </li>
        <li class="page-item"
            *ngFor="let item of numbers | limit: current:2"
            [class.active]="item?.page === current">
            <a class="page-link"
               (click)="onChangePage(item?.page)">
                {{ item?.label }}
            </a>
        </li>
        <li class="page-item"
            [class.disabled]="hasLastPage">
            <a class="page-link" (click)="nextPage()">
                >
            </a>
        </li>
    </ul>
</nav>
`,
    styles: [``],
})

export class AtxTablePaginationComponent implements OnInit, OnChanges {
    @Input() public readonly model;
    @Input() public readonly justifyContent: string = 'center';

    @Output('onChangePage') public readonly fireChangePage: EventEmitter<any> = new EventEmitter();

    public pages: number;
    public current: number;
    public numbers: number[];
    public hasLastPage: boolean;
    public hasFirstPage: boolean;

    public ngOnInit() {
        this.setValuesPagination();
    }

    public ngOnChanges() {
        this.setValuesPagination();
    }

    private setValuesPagination() {
        this.pages = Math.ceil(this.model.total / this.model.limit);
        this.current = (this.model.offset / this.model.limit) + 1;

        this.numbers = Array(this.pages).fill(1).map((x, i) => ++i);
    }

    public onChangePage(page) {
        this.current = page;
        this.fireChangePage.emit(this.current);
    }

    public prevPage() {
        if (this.current - 1 >= 1) {
            this.hasLastPage = false;

            this.onChangePage(this.current - 1);
        } else {
            this.hasFirstPage = true;
        }
    }

    public nextPage() {
        if (this.current + 1 <= this.pages) {
            this.hasFirstPage = false;

            this.onChangePage(this.current + 1);
        } else {
            this.hasLastPage = true;
        }
    }
}
